'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stepSaga = stepSaga;

var _effects = require('redux-saga/effects');

var _metrixCommon = require('metrix-common');

var _reduceReturns = require('../../actions/workflow/reduceReturns');

var _reduceStep = require('../../actions/workflow/reduceStep');

var _reduceStages = require('../../actions/workflow/reduceStages');

var _selectReturns = require('../../selectors/workflow/selectReturns');

var _selectEntity = require('../../selectors/workflow/selectEntity');

var _validation = require('./validation');

var _reduceValid = require('../../actions/workflow/reduceValid');

var _visibility = require('./visibility');

var _reduceControl = require('../../actions/workflow/reduceControl');

var _selectAnonymous = require('../../selectors/workflow/selectAnonymous');

var _selectDynamicDate = require('../../selectors/workflow/selectDynamicDate');

var _reduceStepAnalytics = require('../../actions/workflow/reduceStepAnalytics');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(stepSaga);

function stepSaga(action) {
    var anonymous, session, returns, entity, subfolderPrefix, response, result, dynamicDate, nextStepUrl, redirect, redirectUrl, step;
    return regeneratorRuntime.wrap(function stepSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.put)((0, _metrixCommon.reduceLoading)(true));

                case 2:
                    _context.next = 4;
                    return (0, _effects.select)((0, _selectAnonymous.selectAnonymous)());

                case 4:
                    anonymous = _context.sent;
                    _context.next = 7;
                    return (0, _metrixCommon.getSessionSaga)();

                case 7:
                    session = _context.sent;
                    _context.next = 10;
                    return (0, _effects.select)((0, _selectReturns.selectReturns)());

                case 10:
                    returns = _context.sent;
                    _context.next = 13;
                    return (0, _effects.select)((0, _selectEntity.selectEntity)());

                case 13:
                    entity = _context.sent;
                    subfolderPrefix = process.env.REACT_APP_SUBFOLDER_NAME ? '/' + process.env.REACT_APP_SUBFOLDER_NAME : '';
                    _context.next = 17;
                    return (0, _effects.call)(fetch, subfolderPrefix + '/api/workflow/step', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': anonymous === true && (!session.authenticationToken || !session.authenticationToken.token) ? null : session.authenticationToken.token,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            control: {
                                direction: action.payload,
                                entity: entity
                            },
                            returns: returns
                        })
                    });

                case 17:
                    response = _context.sent;
                    _context.next = 20;
                    return (0, _effects.call)([response, 'json']);

                case 20:
                    result = _context.sent;
                    _context.next = 23;
                    return (0, _effects.select)((0, _selectDynamicDate.selectDynamicDate)());

                case 23:
                    dynamicDate = _context.sent;
                    _context.next = 26;
                    return (0, _effects.put)((0, _metrixCommon.reduceOperation)(result.operation));

                case 26:
                    if (!result.operation.status) {
                        _context.next = 58;
                        break;
                    }

                    if (!(result.step.isAuthenticationRequired && !session.authenticationToken)) {
                        _context.next = 33;
                        break;
                    }

                    nextStepUrl = new URL(window.location.href);

                    nextStepUrl.hash = result.control.step;
                    if (result.step.authenticationEmail) nextStepUrl.searchParams.append('authenticationEmail', result.step.authenticationEmail);
                    if (result.step.isCommercialProduct !== undefined) nextStepUrl.searchParams.append('isCommercialProduct', result.step.isCommercialProduct);

                    return _context.abrupt('return', window.location = location.origin + '/client/login?' + btoa(nextStepUrl.href));

                case 33:
                    if (!(result.returns && result.returns.length > 0)) {
                        _context.next = 40;
                        break;
                    }

                    redirect = result.returns.find(function (item) {
                        return item.code === 'AutoRedirect';
                    });

                    if (!(redirect && redirect.elements && redirect.elements.length > 0)) {
                        _context.next = 40;
                        break;
                    }

                    redirectUrl = redirect.elements.find(function (item) {
                        return item.code === 'Target';
                    });

                    if (!(redirectUrl && redirectUrl.value)) {
                        _context.next = 40;
                        break;
                    }

                    window.location.href = redirectUrl.value;
                    return _context.abrupt('return');

                case 40:
                    if (!(result.step && result.step.stepAnalytics)) {
                        _context.next = 43;
                        break;
                    }

                    _context.next = 43;
                    return (0, _effects.put)((0, _reduceStepAnalytics.reduceStepAnalytics)(result.step.stepAnalytics));

                case 43:
                    step = result.step;

                    step = (0, _visibility.setStepVisibility)(step, result.returns);
                    step = (0, _validation.setStepValidation)(step, result.returns, dynamicDate);
                    _context.next = 48;
                    return (0, _effects.put)((0, _reduceStep.reduceStep)(step));

                case 48:
                    _context.next = 50;
                    return (0, _effects.put)((0, _reduceControl.reduceControl)(result.control));

                case 50:
                    _context.next = 52;
                    return (0, _effects.put)((0, _reduceValid.reduceValid)((0, _validation.getStepValidation)(step)));

                case 52:
                    _context.next = 54;
                    return (0, _effects.put)((0, _reduceStages.reduceStages)(result.stages));

                case 54:
                    _context.next = 56;
                    return (0, _effects.put)((0, _reduceReturns.reduceReturns)(result.returns));

                case 56:
                    window.location.hash = result.control.step;
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });

                case 58:
                    _context.next = 60;
                    return (0, _effects.put)((0, _metrixCommon.reduceLoading)(false));

                case 60:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}